module.exports = __webpack_public_path__ + "img/homeplus.a624a9ed.jpg";